module.exports = [{
      plugin: require('/tmp/28c53a44/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
